import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctString } from '../../../../Fct/generics';
export var Symbol = createPlugin({
    protocol: 'ERC721',
    type: 'GETTER',
    method: 'symbol',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc721', isPreview: true, }),
                methodParams: {},
            },
            output: {
                symbol: new FctString({ innerIndex: 0 }),
            },
        });
    },
});
